import { DiningRequest, PaginatedResponse } from "../types/request";

export interface DiningRequestParams {
  page?: number;
  limit?: number;
  search?: string;
  status?: string;
  sortBy?: string;
  sortOrder?: "asc" | "desc";
}

export interface UpdateStatusParams {
  status: string;
  completedAt?: string;
}

export const createDiningRequestsApi = (
  callApi: (config: any) => Promise<any>
) => {
  return {
    /**
     * Fetch dining requests with pagination and filtering
     */
    async fetchDiningRequests(
      params: DiningRequestParams
    ): Promise<PaginatedResponse<DiningRequest>> {
      const queryParams = new URLSearchParams();

      if (params.page) queryParams.append("page", params.page.toString());
      if (params.limit) queryParams.append("limit", params.limit.toString());
      if (params.search) queryParams.append("search", params.search);
      if (params.status) queryParams.append("status", params.status);
      if (params.sortBy) queryParams.append("sortBy", params.sortBy);
      if (params.sortOrder) queryParams.append("sortOrder", params.sortOrder);

      const response = await callApi({
        method: "GET",
        url: `/management/dining?${queryParams.toString()}`,
      });

      return response.data;
    },

    /**
     * Fetch a specific dining request by ID
     */
    async fetchDiningRequestById(requestId: string): Promise<DiningRequest> {
      const response = await callApi({
        method: "GET",
        url: `/management/dining/${requestId}`,
      });

      return response.data;
    },

    /**
     * Update dining request status
     */
    async updateDiningRequestStatus(
      requestId: string,
      params: UpdateStatusParams
    ): Promise<DiningRequest> {
      const response = await callApi({
        method: "PUT",
        url: `/management/dining/${requestId}/status`,
        data: params,
      });

      return response.data;
    },
  };
};

export type DiningRequestsApi = ReturnType<typeof createDiningRequestsApi>;
